import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCuvkbOMKkuHR5oBU8tT1WWkxn5ngaqY1s",
  authDomain: "zoi-staging-crazy.firebaseapp.com",
  databaseURL: "https://zoi-staging-crazy-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "zoi-staging-crazy",
  storageBucket: "zoi-staging-crazy.appspot.com",
  messagingSenderId: "1098029127956",
  appId: "1:1098029127956:web:47edc5d01d5d9c971c4a01",
  measurementId: "G-R01227280Q"
};
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
export { db };